<div *ngIf="showHorizontal && showVertical" class="flex flex-column gap-2">
  <div class="flex gap-2">
    <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 0, y: 2 }"></ng-container>
    <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 1, y: 2 }"></ng-container>
    <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 2, y: 2 }"></ng-container>
  </div>
  <div class="flex gap-2">
    <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 0, y: 1 }"></ng-container>
    <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 1, y: 1 }"></ng-container>
    <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 2, y: 1 }"></ng-container>
  </div>
  <div class="flex gap-2">
    <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 0, y: 0 }"></ng-container>
    <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 1, y: 0 }"></ng-container>
    <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 2, y: 0 }"></ng-container>
  </div>
</div>

<div *ngIf="showHorizontal && !showVertical" class="flex gap-2">
  <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 0, y: 1 }"></ng-container>
  <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 1, y: 1 }"></ng-container>
  <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 2, y: 1 }"></ng-container>
</div>

<div *ngIf="!showHorizontal && showVertical" class="flex flex-column gap-2">
  <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 1, y: 2 }"></ng-container>
  <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 1, y: 1 }"></ng-container>
  <ng-container [ngTemplateOutlet]="anchorButton" [ngTemplateOutletContext]="{ x: 1, y: 0 }"></ng-container>
</div>

<ng-template let-selfX="x" let-selfY="y" #anchorButton>
  <button
    [icon]="getIcon(selfX, selfY)"
    (click)="changeAnchor(selfX, selfY)"
    pButton
    class="p-button-icon-only p-button-text anchor-button"
  ></button>
</ng-template>
